import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DSButton, InputLabel } from "components/UI/atoms";
import { useShowSnackbar } from "hooks/useShowSnackbar";
import { validationSchema } from "./utils/validationSchema";
import { useHandleResetEmailSubmit } from "./utils/useHandleResetEmailSubmit";
import "./index.scss";

export const RecoverPasswordForm = () => {
  const { register, handleSubmit: handleFormSubmit } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const { addNotification } = useShowSnackbar();
  const { handleSendResetInstructions, isLoading } =
    useHandleResetEmailSubmit();

  const onSubmitForm = async ({ email }) => {
    await handleSendResetInstructions({ email });
  };

  const onFormInvalid = (error) => {
    addNotification({
      message: error.email.message,
      variant: "error",
      persist: true
    });
  };

  return (
    <form
      className="recover-password-form"
      onSubmit={handleFormSubmit(onSubmitForm, onFormInvalid)}
    >
      <InputLabel
        label="Email"
        id="email"
        required
        customClassname="recover-password-input"
        {...register("email", { required: true })}
      />
      <DSButton
        type="submit"
        variant="secondary"
        customClassName="send-reset-button"
        disabled={isLoading}
      >
        Send Reset Link
      </DSButton>
    </form>
  );
};
